module.exports = __webpack_public_path__ + "static/media/POI_visit_count.c85add9f.svg";